import React from "react";

import { BodyMedium } from "Cobalt/BodyText";

import AgentImg from "./AgentImg";

import makeBem from "Utils/makeBem";

const bem = makeBem("AgentHeader");

const AgentHeader = ({ children }) => (
  <div className={bem()}>
    <AgentImg size="small" />
    <BodyMedium
      style={{
        padding: "12px",
      }}
      className={bem("agentText")}
    >
      {children}
    </BodyMedium>
  </div>
);

export default AgentHeader;
